import { combineReducers } from "redux";
import user from "./user";
import language from "./lang";
import invoice from "./invoice";

export default combineReducers({
  user,
  language,
  invoice
});
